import { constants } from "@newsela/angelou";

import { pollOptionTextCss } from "../PollOptions.style";

const { colors } = constants;

export const interactivePollOptionCss = {
  color: colors.ui.neutral[700],
  justifyContent: "center",
  // Adding to ensure focus styles aren't wider than the focusable element
  maxWidth: "641px",
  // RadionButton from Angelou has a 2px (hidden) border and 4px padding so the
  // bottom margin should be 12px (2px + 4px twice) smaller than designed (32px)
  marginBottom: "20px",
  "&:last-of-type": {
    // The last RadioButton does not need to account for the 2px + 4px twice because
    // there is no option below it. As such, the bottom margin only needs to be
    // 6px smaller than designed
    marginBottom: "26px",
  },
};

export const interactivePollOptionTextCss = [
  {
    border: `1px solid ${colors.ui.neutral[400]}`,
    marginLeft: "5px",
  },
  pollOptionTextCss,
];
